import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../redux/actions";
import SimpleSlider from "../../containers/carousel";
import { browserHistory } from "react-router";
import authAPI from "../../api/authAPI";
import constants from "../../constants";
import { BrowsePageContent } from "../shared/BrowsePageContent";
import ResponsiveNavBtns from "./ResponsiveNavBtns";
import ResponsiveResourcesNew from "./ResponsiveResourcesNew";
import UnattachedPopover from "../shared/UnattachedPopover";
import _ from "lodash";
import ResourceHeading from "../../components/ResourceHeading";
import AddToFolderModal from "../../components/AddToFolder/AddToFolderModal";
import { SnackBarModule } from "../../components/Shared";

let invertMap = [
  "Featured",
  "Reading",
  "Writing",
  "Speaking & Listening",
  "Language",
];

class AssessmentsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: constants.caseMap[this.props.params.strand],
      isFeatured: false,
      DataSource: this.props,
      loadingMore: false,
      pageNumber: 1,
      data: [],
      searchedData: [],
      assessmentDetails: "",
      hasMore: true,
      total: 0,
      searchTotal: 0,
      filter: false,
      queryValue: "",
      multiSelectMode: false,
      multipleItems: [],
      areAllSelected: false,
      selectedItems: [],
      addedMultipleItemsToLibrary: false,
      addedMultipleItemsToFolder: false,
      isBackButtonPressed: false,
      selectedResourceId: "",
      isAddToFolderModalOpen: false,
      addToFolderSuccess: false,
      addToFolderError: false,
      addToFolderErrorMsg:"",
      addToLibrarySuccess: false,
      addToLibraryError: false,
      searchActive: false,
      getSearchNextPage: false,
    };
    window.sessionStorage.setItem("selectedFilters", JSON.stringify([]));
  }

  handlingClick(buttonValue) {
    this.setState({
      buttonClicked: buttonValue,
    });
  }

  _handleAPI(pageNumber, handle) {
    this.props.getAssessmentsAction(pageNumber, handle);
    this.setState({
      isFeatured: false,
    });
  }

  componentWillMount() {
    this._handleAPI(this.state.pageNumber, this.state.path);
  }

  componentWillReceiveProps(next) {
    window.onpopstate = (e) => {
      this.setState({
        isBackButtonPressed: true,
      });
    };
    let path = constants.caseMap[next.params.strand];
    if (
      !this.state.searchActive &&
      next.assessments.data &&
      next.assessments.asyncStatus === "SUCCESS"
    ) {
      if (next.finalFilters.filterList.length === 0) {
        this.setState({
          filter: false,
          total:
            next.assessments.data?.total ??
            next.assessments?.data?.results?.length,
          data: next.assessments?.data?.results,
          loadingMore: false,
        });
      }
    }

    if (this.props.params.strand !== next.params.strand) {
      this.setState(
        {
          path,
          data: [],
          pageNumber: 1,
          queryValue: "",
        },
        () =>
          this._handleAPI(
            this.state.pageNumber,
            constants.caseMap[next.params.strand]
          )
      );
    } else if (
      next.finalFilters &&
      next.finalFilters.filterList &&
      this.state.path !== 0
    ) {
      let queryString = constants.getQueryStringFromFilterList(
        next.finalFilters.filterList
      );
      if (this.state.queryValue !== queryString && queryString) {
        let filterInfinite = this.state.path;
        authAPI
          .getAssessments(
            1,
            filterInfinite,
            queryString,
            this.state.isBackButtonPressed
          )
          .then((resp) => {
            this.setState({
              data: resp.results ? resp.results : [],
              total: resp?.total ?? resp?.results?.length,
              pageNumber: 1,
              filter: true,
              queryValue: queryString,
              hasMore: true,
            });
          });
      }
    }
    if (next.assessmentDetails) {
      if (next.assessmentDetails.asyncStatus === "PENDING") {
        this.setState({ status: "PENDING" });
      } else if (next.assessmentDetails.asyncStatus === "FAILURE") {
        this.setState({ assessmentDetails: "FAILURE" });
      } else if (
        next.assessmentDetails.asyncStatus === "SUCCESS" &&
        next.assessmentDetails.data.status === "FAILURE FOR PRINT ONLY USER"
      ) {
        this.setState({ status: "FAILURE FOR PRINT ONLY USER" });
      } else if (
        next.assessmentDetails.asyncStatus === "SUCCESS" &&
        next.assessmentDetails.data.status === "FAILURE FOR NOT APPROVED"
      ) {
        this.setState({ status: "FAILURE FOR NOT APPROVED" });
      } else if (next.assessmentDetails.asyncStatus === "SUCCESS") {
        this.setState({
          assessmentDetails: next.assessmentDetails.data,
          status: "SUCCESS",
          selectedResourceId: next.assessmentDetails.data._id,
        });
      }
    }
  }

  _loadMore() {
    if (
      this.state.searchActive &&
      !this.state.getSearchNextPage &&
      this.state.nextPage !== -1 &&
      this.state.hasMore
    ) {
      setTimeout(() => {
        this.setState({ getSearchNextPage: true });
      }, 1000);
    } else if (this.props.assessments?.asyncStatus === "SUCCESS") {
      setTimeout(() => {
        if (this.state.total > this.state?.data?.length) {
          let strandInfinite = constants.caseMap[this.props.params.strand],
            filtersSet =
              this.props.finalFilters &&
              this.props.finalFilters.filterList &&
              this.props.finalFilters.filterList.length > 0,
            eitherFiltersSetOrQueryEmpty =
              (filtersSet && this.state.queryValue !== "") ||
              (!filtersSet && this.state.queryValue === "");

          if (
            this.props.params.strand !== "featured" &&
            eitherFiltersSetOrQueryEmpty
          ) {
            authAPI
              .getAssessments(
                this.state.pageNumber + 1,
                strandInfinite,
                this.state.queryValue
              )
              .then((resp) => {
                if (resp.total && resp?.results) {
                  this.setState({
                    total: resp.total,
                    data: _.concat(this.state.data, resp.results),
                    pageNumber: Number(resp.currentPage),
                    loadingMore: false,
                    filter: false,
                  });
                }
              });
          }
        } else {
          this.setState({
            loadingMore: false,
            hasMore: false,
          });
        }
      }, 1000);
    }
  }

  addMultipleItems = (aid) => {
    this.state.multipleItems.push(aid);
    this.setState({ multipleItems: this.state.multipleItems });
  };

  deleteItem = (aid) => {
    let idx = this.state.multipleItems.indexOf(aid);
    this.state.multipleItems.splice(idx, 1);
    this.setState({ multipleItems: this.state.multipleItems });
  };

  addMultipleItemsToLibrary = () => {
    for (let i = 0; i < this.state.multipleItems.length; i++) {
      this.props
        .postAddAssessmentToLibraryAction(this.state.multipleItems[i])
        .then((response) => {
          if (response.statusCode === 200) {
            console.log("Item added to library", this.state.multipleItems[i]);
          } else {
            console.log(
              "Error ! Item not added to library",
              this.state.multipleItems[i]
            );
          }
        })
        .catch(function (error) {
          console.log("Exception! Item not added to library");
        });
    }
  };

  addMultipleItemToFolder = () => {
    let itemTypes = [];
    for (let i = 0; i < this.state.multipleItems.length; i++) {
      itemTypes.push("Assessment");
    }

    browserHistory.push({
      pathname: "/library/addfolder",
      state: {
        libraryItemId: this.state.multipleItems,
        libraryItemType: itemTypes,
        isLibrary: false,
      },
    });
    this.props.saveAssignmentItemAction(itemTypes, this.state.multipleItems);
  };

  //This function expects to be bound in a child component's onClick
  handleClickForResourcesThumbnail = function (item) {
    if (this.props.multiSelectMode) {
      if (this.props.multipleItems.indexOf(item._id) === -1) {
        this.props.addMultipleItems(item._id, item.type);
      } else {
        this.props.deleteItem(item._id, item.type);
      }
    } else {
      browserHistory.push(`/assessments/${item._id}`);
    }
  };

  //This function expects to be bound in a child component's onClick
  handleClickForResourcesAddBtn = function (item) {
    if (this.props.multiSelectMode) {
      if (this.props.multipleItems.indexOf(item._id) === -1) {
        this.props.addMultipleItems(item._id, item.type);
      } else {
        this.props.deleteItem(item._id, item.type);
      }
    } else {
      //This replaces "showTooltip" in popover.
      this.setState({
        isTooltipActive: true,
        success: false,
        showDatePicker: false,
      });
    }
  };

  handleAddMultiple = function (desktop) {
    this.addMultipleItemsToLibrary();
    this.setState(
      {
        multiSelectMode: !this.state.multiSelectMode,
        addedMultipleItemsToLibrary: true,
      },
      () => {
        if (desktop)
          setTimeout(
            () =>
              this.setState({
                addedMultipleItemsToLibrary: false,
                multipleItems: [],
              }),
            3000
          );
      }
    );
  };

  handleAddMultipleToFolder = function (desktop) {
    this.addMultipleItemToFolder();
    this.setState(
      {
        multiSelectMode: !this.state.multiSelectMode,
        addedMultipleItemsToFolder: true,
      },
      () => {
        if (desktop)
          setTimeout(
            () =>
              this.setState({
                addedMultipleItemsToFolder: false,
                multipleItems: [],
              }),
            3000
          );
      }
    );
  };

  handleSelectResourceClick = (item) => {
    if (this.props.multiSelectMode) {
    } else if (item?._id) {
      this.props.getAssessmentDetailsAction(item._id);
    }
  };

  updateFromSearch = (data, total, clearSearch, nextPage) => {
    this.setState({
      searchTotal: total ?? data?.length ?? 0,
      searchedData: data ?? [],
      searchActive: clearSearch ? false : true,
      hasMore: nextPage !== -1 ? true : false,
    });
  };

  handleSuccessSnackBar = () => {
    this.handleCancel();
    this.setState({ isAddToFolderModalOpen: false });
    this.setState({ addToFolderSuccess: true });
    setTimeout(() => {
      this.setState({ addToFolderSuccess: false });
    }, 3000);
  };

  handleErrorSnackBar = (msg) => {
    this.handleCancel();
    this.setState({ isAddToFolderModalOpen: false });
    this.setState({ 
      addToFolderError: true,
      addToFolderErrorMsg: msg
    });
    setTimeout(() => {
      this.setState({ addToFolderError: false });
    }, 3000);
  };

  handleSuccessSnackBarLibrary = () => {
    this.handleCancel();
    this.setState({ addToLibrarySuccess: true });
    setTimeout(() => {
      this.setState({ addToLibrarySuccess: false });
    }, 3000);
  };

  handleErrorSnackBarLibrary = () => {
    this.handleCancel();
    this.setState({ addToLibraryError: true });
    setTimeout(() => {
      this.setState({ addToLibraryError: false });
    }, 3000);
  };

  handleBulkAddToFolderModalOpen = () => {
    this.setState({ isAddToFolderModalOpen: true });
  };

  handleBulkAddToFolderModalClose = () => {
    this.setState({ isAddToFolderModalOpen: false });
  };

  handleCancel = () => {
    this.handleDeselectAll();
    this.setState({ multiSelectMode: !this.state.multiSelectMode });
  };

  handleMultiSelect = (item) => {
    const copyArr = [...this.state.selectedItems];
    if (copyArr.length !== 0) {
      if (!copyArr.filter((e) => e.item_id === item._id).length > 0) {
        copyArr.push({
          item_id: item._id,
          item_name: item.name,
          item_type: "Assessment",
        });
        let uniqueItems = [
          ...new Map(copyArr.map((v) => [v.item_id, v])).values(),
        ];
        this.setState({ selectedItems: uniqueItems });
      } else {
        copyArr.splice(
          copyArr.findIndex((x) => x.item_id === item._id),
          1
        ); //deleting
        this.setState({ selectedItems: copyArr });
      }
    } else {
      copyArr.push({
        item_id: item._id,
        item_name: item.name,
        item_type: "Assessment",
      });
      let uniqueItems = [
        ...new Map(copyArr.map((v) => [v.item_id, v])).values(),
      ];
      this.setState({ selectedItems: uniqueItems });
    }
  };

  handleSelectAll = () => {
    this.setState({ areAllSelected: true });
    const copyArr = [];
    this.state?.data?.forEach((item) => {
      copyArr.push({
        item_id: item._id,
        item_name: item.name,
        item_type: "Assessment",
      });
    });
    this.setState({ selectedItems: copyArr });
  };

  handleDeselectAll = () => {
    this.setState({ areAllSelected: false });
    this.setState({ selectedItems: [] });
  };

  handleOpenMultiselect = () => {
    this.setState({ multiSelectMode: !this.state.multiSelectMode });
  };

  handleAddToLibrary = () => {
    try {
      authAPI.bulkAddToLibrary(this.state.selectedItems).then((res) => {
        if (res.status === 200) {
          this.handleSuccessSnackBarLibrary();
        } else {
          this.handleErrorSnackBarLibrary();
        }
      });
    } catch (err) {
      console.log(
        "%cERROR: ",
        "color:white; background: #41AE75; font-size: 24px",
        err
      );
    }
  };

  getResources = () => {
    const resources = this.state?.searchActive
      ? this.state.searchedData
      : this.state.data;
    return resources?.length >= 0
      ? resources.map((item, i) => (
          <ResponsiveResourcesNew
            item={item}
            key={`assessment-resource-${i}`}
            i={i}
            handleClickForResourcesThumbnail={
              this.handleClickForResourcesThumbnail
            }
            handleClickForResourcesAddBtn={this.handleClickForResourcesAddBtn}
            handleSelectResourceClick={this.handleSelectResourceClick}
            multiSelectMode={this.state.multiSelectMode}
            addMultipleItems={this.addMultipleItems}
            deleteItem={this.deleteItem}
            multipleItems={this.state.multipleItems}
            scheduleTask={this.props.postScheduledTasksAction}
            active={
              parseInt(item?._id) === parseInt(this.state.selectedResourceId)
            }
            handleMultiSelect={this.handleMultiSelect}
            selectedItems={this.state.selectedItems}
          />
        ))
      : [];
  };

  render() {
    const navButtons = (
      <ResponsiveNavBtns
        displayableSelectedStrand={
          invertMap[constants.caseMap[this.props.params.strand]]
        }
        onSelectMenuItem={this.onSelectMenuItem}
        selectedStrand={this.props.params.strand}
        btnOptions={[
          "featured",
          "reading",
          "writing",
          "language",
          "speaking-listening",
        ]}
      />
    );

    const featuredSliders = (
      <div style={{ height: "100%" }}>
        {this.props.featuredAssessments.asyncStatus === "SUCCESS" && (
          <div style={{ height: "100%" }}>
            {this.props.featuredAssessments.data[1] && (
              <SimpleSlider
                name={"Featured Reading"}
                carouselItem="assessments"
                items={this.props.featuredAssessments.data[1].results}
                viewAllUrl="/browse/assessments/reading"
              />
            )}
            {this.props.featuredAssessments.data[2] && (
              <SimpleSlider
                name={"Featured Writing"}
                carouselItem="assessments"
                items={this.props.featuredAssessments.data[2].results}
                viewAllUrl="/browse/assessments/writing"
              />
            )}
            {this.props.featuredAssessments.data[4] && (
              <SimpleSlider
                name={"Featured Language"}
                carouselItem="assessments"
                items={this.props.featuredAssessments.data[4].results}
                viewAllUrl="/browse/assessments/language"
              />
            )}
            {this.props.featuredAssessments.data[3] && (
              <SimpleSlider
                name={"Featured Speaking & Listening"}
                carouselItem="assessments"
                items={this.props.featuredAssessments.data[3].results}
                viewAllUrl="/browse/assessments/speaking-listening"
              />
            )}
          </div>
        )}
      </div>
    );

    const beforeNonFeaturedContent = this.state.addedMultipleItemsToLibrary &&
      this.state.multipleItems.length !== 0 && (
        <UnattachedPopover
          hideTooltip={() => {
            this.setState({ addedMultipleItemsToLibrary: false });
          }}
        >
          <div className="selected-checkbox-icon-add-multiple icon-icon-checkbox" />
          <span style={{ float: "left" }}>
            Successfully added&nbsp;
            <strong>
              {this.state.multipleItems.length}&nbsp;
              {this.state.multipleItems.length === 1 ? (
                <span>item</span>
              ) : (
                <span>items</span>
              )}
            </strong>
            &nbsp;to library
          </span>
          <div>
            <span>
              <button
                className="go-to-my-library-add-multiple"
                onClick={() => browserHistory.push("/library/assessments")}
              >
                GO TO MY LIBRARY
              </button>
            </span>
          </div>
        </UnattachedPopover>
      );

    return (
      <>
        <BrowsePageContent
          name="Assessments"
          isFeatured={this.state.isFeatured}
          resources={this.getResources()}
          navButtons={navButtons}
          resourceHeading={
            <ResourceHeading
              multiSelectMode={this.state.multiSelectMode}
              areAllSelected={this.state.areAllSelected}
              handleOpenMultiselect={this.handleOpenMultiselect}
              handleCancel={this.handleCancel}
              handleDeselectAll={this.handleDeselectAll}
              handleSelectAll={this.handleSelectAll}
              handleAddToLibrary={this.handleAddToLibrary}
              total={
                this.state.searchActive
                  ? this.state?.searchTotal
                  : this.state.total ?? 0
              }
              data={this.state.data}
              handleBulkAddToFolderModal={this.handleBulkAddToFolderModalOpen}
            />
          }
          asyncStatus={
            this.props?.featuredAssessments?.asyncStatus ||
            this.props?.assessments?.asyncStatus
          }
          beforeNonFeaturedContent={beforeNonFeaturedContent}
          hasMore={this.state.hasMore}
          loadMore={this._loadMore.bind(this)}
          featuredSliders={featuredSliders}
          updateFromSearch={this.updateFromSearch}
          getSearchNextPage={this.state.getSearchNextPage}
          setNoSearchNextPage={() =>
            this.setState({ getSearchNextPage: false })
          }
          location={this.props.location}
          selectedResource={
            this.state.assessmentDetails?.id ||
            this.state.assessmentDetails?._id
              ? this.state.assessmentDetails
              : ""
          }
          selectedResourceType={"assessment"}
        />
        {this.state.isAddToFolderModalOpen && (
          <AddToFolderModal
            handleClose={this.handleBulkAddToFolderModalClose}
            handleSuccessSnackbar={this.handleSuccessSnackBar}
            handleErrorSnackbar={this.handleErrorSnackBar}
            selectedItems={this.state.selectedItems}
          />
        )}

        <SnackBarModule
          addToFolderSuccess={this.state.addToFolderSuccess}
          addToFolderError={this.state.addToFolderError}
          addToFolderErrorMsg={this.state.addToFolderErrorMsg}
          addToLibrarySuccess={this.state.addToLibrarySuccess}
          addToLibraryError={this.state.addToLibraryError}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assessments: state.Assessments,
    featuredAssessments: state.FeaturedAssessments,
    finalFilters: state.FilterScale,
    assessmentDetails: state.AssessmentDetails,
  };
};

export default connect(mapStateToProps, actions)(AssessmentsContent);
